import React from 'react';
import PropTypes from 'prop-types';

const SvgDisconnect = ({
  width = 28,
  height = 28,
  color = '#F05146',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.55737 16.1143C4.26183 16.1143 2.40009 14.272 2.40009 11.9996C2.40009 9.72803 4.26183 7.88573 6.55737 7.88573H9.7144"
      stroke={color}
      strokeWidth="1.536"
      strokeLinecap="round"
    />
    <path
      d="M17.3312 7.88573C19.6892 7.88573 21.6 9.72803 21.6 11.9996C21.6 14.272 19.6892 16.1143 17.3312 16.1143H14.2857"
      stroke={color}
      strokeWidth="1.536"
      strokeLinecap="round"
    />
    <path
      d="M15.1999 5.14282L8.79993 18.8572"
      stroke={color}
      strokeWidth="1.536"
      strokeLinecap="round"
    />
  </svg>
);

SvgDisconnect.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export default SvgDisconnect;
